<template>
    <v-dialog
        v-model="show"
        persistent
        max-width="500px">
        <v-card>
            <v-card-title>
                <span class="headline">
                    {{ $vuetify.lang.t('$vuetify.importEmployeeErrorModal.importEmployeeData') }}
                </span>
            </v-card-title>
            <v-card-text class="pb-0">
                <v-row>
                    <v-col
                        cols="12"
                        class="result-label">
                        <div>
                            {{ error.description }}
                        </div>
                        <br>
                        <div>
                            {{ $vuetify.lang.t('$vuetify.importEmployeeErrorModal.downloadErrorFile') }}
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="pb-6 pr-6">
                <v-spacer/>
                <v-btn
                    color="primary"
                    class="mr-3"
                    @click="downloadError()">
                    {{ $vuetify.lang.t('$vuetify.importEmployeesFormModal.download') }}
                </v-btn>
                <v-btn
                    color="primary"
                    @click="closeModal()">
                    {{ $vuetify.lang.t('$vuetify.importEmployeesFormModal.close') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ImportEmployeeErrorModal',

    props: {
        error: {
            type: Object,
            default: null
        }
    },

    data () {
        return {
            show: false
        }
    },

    methods: {
        showModal () {
            this.show = true
        },

        closeModal () {
            this.show = false
        },

        downloadError () {
            this.$emit('download-error-file')
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
